import { render, staticRenderFns } from "./firstLogoRow.vue?vue&type=template&id=4d1a63f4&"
import script from "./firstLogoRow.vue?vue&type=script&lang=js&"
export * from "./firstLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports